import React from 'react';
import { HeadsetStatus } from 'src/features/devices/devices.types';
import { ReactComponent as UseCardIcon } from 'src/icons/OutlineSDCard.svg';
import { ReactComponent as NoCardIcon } from 'src/icons/OutlineSDCardAlert.svg';

const CardStatus: React.FC<{ status: HeadsetStatus; onlyWarning?: boolean; style?: React.CSSProperties }> = ({
  status,
  onlyWarning,
  ...restProps
}) => {
  const cardState = status?.cardState;
  const cardIcon = onlyWarning ? <></> : <UseCardIcon {...restProps} />;
  return cardState !== 'ok' ? <NoCardIcon {...restProps} fill={'red'} /> : cardIcon;
};
export default CardStatus;
